import { useEffect, useState } from "react";
import { PageHeader } from "@/components/layout/PageHeader";
import { Skeleton } from "@/components/ui/skeleton";
import { getTimeline } from "@/lib/api";

const fmt = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleString("it-IT", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
};

export default function AttivitaAgente() {
  const [items, setItems] = useState(null);
  useEffect(() => {
    getTimeline().then(setItems).catch(() => setItems([]));
  }, []);

  if (!items) return <Skeleton className="h-96 bg-white/5" />;

  return (
    <>
      <PageHeader
        eyebrow="Attività Agente"
        title="Cosa sta facendo Nadia"
        subtitle="Registro trasparente di ogni decisione e azione dell'agente autonomo."
      />

      <div className="nadia-card p-5 sm:p-6">
        <ul className="relative border-l border-white/10 ml-2 space-y-6">
          {items.map((it) => (
            <li key={it.id} className="pl-6" data-testid={`timeline-${it.id}`}>
              <span className="absolute -left-[7px] w-3.5 h-3.5 rounded-full bg-[#0B1120] border-2 border-cyan-400/60 shadow-[0_0_12px_rgba(34,211,238,0.4)]" />
              <div className="text-[11px] text-slate-500 font-mono uppercase tracking-wider">
                {fmt(it.timestamp)} · {it.channel || "sistema"}
              </div>
              <div className="mt-1 text-slate-100 font-heading font-semibold text-sm sm:text-base">
                {it.action}
              </div>
              {it.reason ? <div className="text-xs text-slate-400 mt-0.5">{it.reason}</div> : null}
              {it.result ? (
                <div className="mt-2 text-xs text-slate-300 bg-white/[0.02] border border-white/5 rounded-lg px-3 py-1.5 inline-block">
                  {it.result}
                </div>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
